<template>
  <CustomDeleteDialog
    dialogTitle="حذف سوال از بانک سوال"
    dialogId="delete-question-confirmation-dialog"
    okTitle="حذف سوال"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="deleteAQuestion"
  >
    <BCol cols="12">
      <p>
        آیا از حذف سوال
        <span style="font-weight: bold !important">
          {{ selectedQuestionTitle }}
        </span>
        از بانک سوال اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    questionDetails: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async deleteAQuestion() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteAQuestion = new DeleteAQuestion(_this);
        deleteAQuestion.setRequestParam({
          id: _this.questionDetails.questionId,
        });
        await deleteAQuestion.fetch(
          (res) => {
            if (res.isSuccess) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "حذف شد!",
                  icon: "CheckIcon",
                  variant: "success",
                  text: "سوال با موفقیت حذف شد.",
                },
              });
              this.$bvModal.hide("delete-question-confirmation-dialog");
              _this.$emit("refetch");
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "حذف نشد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
                },
              });
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    selectedQuestionTitle() {
      if (this.questionDetails && this.questionDetails.questionText) {
        return this.questionDetails.questionText;
      }
      return "";
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteAQuestion } from "@/libs/Api/Question";
import { BCol } from "bootstrap-vue";
</script>
